import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import Login from './components/Login/Login';
import Dashboard from './pages/Dashboard';
import Reports from './pages/Reports';
import VehicleSettings from './pages/VehicleSettings';
import Geofences from './pages/Geofences';
import AdminPanel from './pages/AdminPanel';
import ClientAccounts from './pages/ClientAccounts';

const PrivateRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const token = useAuthStore((state) => state.token);
  return token ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <PrivateRoute>
              <Reports />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <VehicleSettings />
            </PrivateRoute>
          }
        />
        <Route
          path="/geofences"
          element={
            <PrivateRoute>
              <Geofences />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/clients"
          element={
            <PrivateRoute>
              <ClientAccounts />
            </PrivateRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </Router>
  );
}

export default App;
